export const filterMixin = {
  data() {
    return {
      search_parameters: {},
      items: [],
      downloadItems: [],
      filteredItems:[],
      filters:[],
      sortBy: 'source_id',
      sortDesc: true,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [ 5, 10, 15, 50, 100 ],
      noResultsFound: false,
      showSubmit: false,
      count:0,
      dismissCountDown: 0,
      dismissSecs: 5,
      filter: null,
      variants: ['primary', 'secondary', 'danger', 'warning', 'success', 'info', 'dark'],
      lastUpdated: '',
    }
  },
  computed: {
    downloadData () {
      var contentType = "application/json"
      var dData = JSON.stringify(this.downloadItems, null, 2)
      var blob = new Blob([dData], {type: contentType})
      var url = window.URL.createObjectURL(blob)
      return url
    }
  },
  mounted() {
    var tnow = Math.round((new Date()).getTime() / 1000);
    if (Object.keys(localStorage).includes('lastServiceUpdate')) {
      if (tnow - localStorage['lastServiceUpdate'] >= 300){
        localStorage['lastServiceUpdate'] = tnow
        this.reloadWindow()
      }
    } else {
      localStorage['lastServiceUpdate'] = tnow
      this.reloadWindow()
    }
  },
  methods: {
    reloadWindow () {
      window.location.reload(true)
    },
    fetchLastUpdated (updated_for) {
      var url = 'https://catalog.chime-frb.ca/last-updated/' + updated_for
      this.$http.get(url, {responseType: 'json', timeout: 10000})
        .then(response => {
          this.lastUpdated = new Date(response.body['unix_time'] * 1e3).toUTCString().slice(0, -3) + 'UTC'
        })
    },
    checkIfDisplay(value) {
      return !(String(value).startsWith('<') || String(value).length === 0 || String(value) === undefined)
    },
    sortOptions () {
      // Create an options list from our fields
      return this.showfields
        .filter(f => f.sortable)
        .map(f => { return { text: f.label, value: f.key } })
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    addFilter () {
      // Add filter object to be rendered
      this.filters.push({
        'value': 'null',
        id: this.count++
      })
      this.showSubmit = true
    },
    deleteFilter (id) {
      // Delete filter object based on id
      for (var i = 0; i < this.filters.length; i++) {
        if (this.filters[i]['id'] == id) {
          this.filters.splice(i, 1)
        }
      }
      if (this.filters === undefined || this.filters == 0) {
        this.showSubmit = false
      }
    },
    onFilterChange (filter) {
      // When value of a filter is changed by user, immediatly delete it if another filter already has that value, 
      // and alert user
      for (var i = 0; i < this.filters.length; i++){
        if (this.filters[i]['value'] == filter['value'] && filter['value'] && this.filters[i]['id'] != filter['id']) {
          this.deleteFilter(filter['id'])
          this.dismissCountDown = this.dismissSecs
        }
      }
    },
    countDownChanged (dismissCountDown) {
      // Keeps track of when to dismiss the duplicate filters alert
      this.dismissCountDown = dismissCountDown
    },
    removeSearchParameters (parameter) {
      // When filter is deleted, also deletes search parameter associated with it
      for (var search in this.search_parameters) {
        if (search.indexOf(parameter) != -1) {
          delete this.search_parameters[search]
        }
      }
    },
    isToBeAdded (item) {
      // Go though filters, check if the id is appropriate and if the burst parameters are in the appropriate range
      for (var i=0; i < this.filters.length; i++){
        var parameter = this.filters[i]['value']
        if ((parameter == 'id' && item['source_id'] != this.search_parameters['id'] && this.search_parameters['id']) ||
            (parameter != 'id' && !this.isInRange(parameter, item[parameter]))) {
          return false
        }
      }
      return true
    },
    isInRange (parameter, source_data) {
      // Check if a certain parameter of a burst is within its corresponding filter's range
      var min_search = this.search_parameters[parameter + '_min']
      var max_search = this.search_parameters[parameter + '_max']
      if (parameter == 'date' && min_search) {
        min_search = new Date(min_search)
      }
      if (parameter == 'date' && max_search) {
        max_search = new Date(max_search)
      }
      if (!min_search && !max_search) {
        return true
      } else if (!min_search) {
        return source_data <= max_search
      } else if (!max_search) {
        return (source_data >= min_search)
      } else {
        return (source_data <= max_search && source_data >= min_search)
      }
    }
  }
}
